import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWeddingPartyList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/weddingPartyList" */ './WeddingPartyList'), 'WeddingPartyList');
